module.exports = __webpack_public_path__ + "img/bg.5c8039b9.png";